export const NUMBER_OF_TX_PER_PAGE = 10
export const DISABLE_CAMPAIGN_CHECK_NUMBER_OF_TX = 100

export const LOYALTY_EVENT_TYPES = {
  CODE_TO_POINTS: 'code_to_points',
  CODE_TO_NFT: 'code_to_nft',
  CODE_TO_EXTERNAL_REWARDS: 'code_to_external_rewards',
  CREDIT_POINTS: 'credit_points',
  DEBIT_POINTS: 'debit_points',
  POINTS_TO_REWARDS: 'points_to_rewards',
  ON_DEMAND_CODE_CREATION: 'on_demand_code_creation',
  NFT_PERSONALISATION: 'nft_personalisation',
  SIGNUP_BONUS: 'signup_bonus',
  EXCHANGE: 'exchange',
  REVERT_EXCHANGE: 'revert_exchange',
  POINTS_TO_NFT_EXCHANGE: 'points_to_nft_exchange',
  CREDIT_NFT: 'credit_nft',
  NFT_TRANSFER: 'nft_transfer',
  NFT_SALE: 'nft_sale'
}

export const TRANSACTION_TYPE = {
  REWARD: 'reward',
  REDEEM: 'redeem'
}

export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
}

export const TRANSACTION_STATUS_LABEL = {
  FUTURE: 'future'
}

export const TRIGGERED_BY_LABEL_MATCH = {
  CASHBACK: 'cashback from',
  TIER_CASHBACK_BONUS: 'tier cashback bonus',
  COE_INTEGRATION: 'coe integration',
  LOYALTY_POINTS_PURCHASED: 'loyalty points purchase',
  QUEST: 'quest',
  REFERRAL: 'referral',
  SLEAP: 'sleap',
  UGC: 'ugc',
  MILESTONE_FEATURE: 'milestone feature',
  PURCHASE_TIER: 'purchase tier',
  EMPLOYEE_FIRST_NAMES: [
    'aaron',
    'arnaud',
    'claudio',
    'gianluca',
    'gioele',
    'pascal'
  ]
}
